import { createAction } from "redux-actions";

export const getShopifyCollections = createAction(
  "API:COLLECTIONS_GET_SHOPIFY_COLLECTIONS",
  storeId => ({
    url: `/api/v1/stores/${storeId}/collections`
  })
);
